export default "__VITE_ASSET__CsfzjrOM__"